// src/components/ModalContactar.jsx
import React from "react";

const ModalViewPostulante = ({
    postulante,
    onClose,
}) => {

    return (
        <div className="modal-overlay">
            <div className="modal-content-compact">
                <div className="modal-header">
                    <h3>Postulante</h3>
                    <button className="modal-close-btn" onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className="postulante-info-compact">
                    {postulante.descripcion_postulacion && (
                        <div className="info-item">
                            <span className="info-label">Tipo de Postulación:</span>
                            <span className="info-value">{postulante.descripcion_postulacion}</span>
                        </div>
                    )}

                    {postulante.descripcion_documento && (
                        <div className="info-item">
                            <span className="info-label">Tipo de Documento:</span>
                            <span className="info-value">{postulante.descripcion_documento}</span>
                        </div>
                    )}

                    {postulante.numero_documento && (
                        <div className="info-item">
                            <span className="info-label">Número de Documento:</span>
                            <span className="info-value">{postulante.numero_documento}</span>
                        </div>
                    )}

                    {postulante.nombre_referido && (
                        <div className="info-item">
                            <span className="info-label">Nombre:</span>
                            <span className="info-value">{postulante.nombre_referido}</span>
                        </div>
                    )}

                    {postulante.email && (
                        <div className="info-item">
                            <span className="info-label">Correo Electrónico:</span>
                            <span className="info-value">{postulante.email}</span>
                        </div>
                    )}

                    {postulante.telefono && (
                        <div className="info-item">
                            <span className="info-label">Teléfono:</span>
                            <span className="info-value">{postulante.telefono}</span>
                        </div>
                    )}

                    {postulante.edad !== null && postulante.edad !== '' && (
                        <div className="info-item">
                            <span className="info-label">Edad:</span>
                            <span className="info-value">{postulante.edad} años</span>
                        </div>
                    )}
                    {postulante.fecha_created !== null && postulante.fecha_created !== '' && (
                        <div className="info-item">
                            <span className="info-label">Fecha Solicitud:</span>
                            <span className="info-value">{new Date(postulante.fecha_created).toLocaleString('es-PE', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                                hour12: true // 👈 esto activa el formato AM/PM
                            })} </span>
                        </div>
                    )}
                     <div className="modal-buttons-compact">
                        <button
                            type="button"
                            className="btn btn-secondary-compact"
                            onClick={onClose}
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
               
            </div>
        </div>
    );
};

export default ModalViewPostulante;
